module.exports = (__webpack_require__(3))(28);


//////////////////
// WEBPACK FOOTER
// delegated ./src/models/FolderModel.js from dll-reference girder_lib
// module id = 51
// module chunks = 0